import moment from 'moment'
import _ from 'lodash'

export const dateTimeMethod = {
  regular(key) {
    switch (key) {
      case 'DAILY':
        return 'day'
      case 'WEEKLY':
        return 'week'
      case 'MONTHLY':
        return 'month'
      case 'YEARLY':
        return 'year'
      default:
        return null
    }
  },
  utcToDate(date) {
    if (date) {
      return moment.utc(date).toDate()
    }
    return ''
  },
  dateToUTC(date) {
    return moment(date, 'YYYY-MM-DD HH:mm').utc().format('YYYY-MM-DDTHH:mm:ss')
  },
  dateTimeFormat(date, format = 'D MMMM YYYY', localTime = true) {
    if (!date || !moment(date).isValid()) return ''
    return moment(localTime ? this.utcToDate(date) : date).format(format)
  },
  weekOfMonth(input = moment()) {
    const firstDayOfMonth = input.clone().startOf('month')
    const firstDayOfWeek = firstDayOfMonth.clone().startOf('week')
    const offset = firstDayOfMonth.diff(firstDayOfWeek, 'days')
    return Math.ceil((input.date() + offset) / 7)
  },
  weekdayOfMonth(input = moment()) {
    let firstDayOfMonth = input.clone().startOf('month')
    let countDuplicate = 1
    if (firstDayOfMonth.format('D') === input.format('D') && input.format('D') === '1') {
      return 1
    }
    do {
      if (firstDayOfMonth.format('dddd') === input.format('dddd')) {
        countDuplicate++
      }
      firstDayOfMonth = firstDayOfMonth.add(1, 'day')
    } while (firstDayOfMonth.format('D') !== input.format('D'))
    return countDuplicate
  },
  formatTimeDuration(time) {
    if (!time || !moment(time).isValid()) return ''
    const hours = moment(time).hours()
    const minutes = moment(time).minutes()
    return `${(hours + +(1 / (60 / minutes)).toFixed(2)).toFixed(2)} Hrs`
  },
  dateTimeDurationText(time) {
    if (!time || !moment(time).isValid()) return ''
    const hours = moment(time).hours()
    const minutes = moment(time).minutes()
    return `${hours > 1 ? `${hours} Hrs` : `${hours} Hr`} ${minutes > 1 ? `${minutes} minutes` : `${minutes} minute`} `
  },
  shortTextStartEndDate(data) {
    // Example: 24 - 27 Jan 2022
    const startDate = moment(data.startDate).isValid() ? moment(data.startDate) : ''
    const endDate = moment(data.endDate).isValid() ? moment(data.endDate) : ''
    if (!startDate || !endDate) return ''
    let startDateText = null
    if (startDate.year() !== endDate.year()) {
      startDateText = startDate.format('D MMM YYYY')
    } else if (startDate.month() !== endDate.month()) {
      startDateText = startDate.format('D MMM')
    } else if (startDate.date() !== endDate.date()) {
      startDateText = startDate.format('D')
    }
    if (startDateText) {
      return startDateText + ' - ' + endDate.format('D MMM YYYY')
    }
    return endDate.format('D MMM YYYY')
  },
  formatScheduleList(start, end, schedule, customTime) {
    const a = moment
    let textDuration = ''
    if (start && end) {
      const startDate = moment(this.utcToDate(start))
      const endDate = moment(this.utcToDate(end))
      if (customTime) {
        const label = customTime.label.split(',')[0].replace('Repeat ', '').replace('every', 'Every')
        textDuration = `${label}, ${startDate.format('HH:mma')} - ${endDate.format('HH:mma')}`
      } else {
        switch (schedule) {
          case 'DAILY':
            textDuration = `Everyday, ${startDate.format('HH:mma')} - ${endDate.format('HH:mma')}`
            break
          case 'WEEKLY':
            textDuration = `Every ${startDate.format('dddd')}, ${startDate.format('HH:mma')} - ${endDate.format(
              'HH:mma'
            )}`
            break
          case 'MONTHLY':
            textDuration = `Every month, ${startDate.format('HH:mma')} - ${endDate.format('HH:mma')}`
            break
          case 'YEARLY':
            textDuration = `Every year, ${startDate.format('HH:mma')} - ${endDate.format('HH:mma')}`
            break
          default:
            textDuration = `${startDate.format('HH:mma')} - ${endDate.format('HH:mma')}`
        }
      }
      return {
        textFromToDate: this.shortTextStartEndDate({
          startDate,
          endDate,
        }),
        textDuration,
      }
    }
    return {
      textFromToDate: '',
      textDuration,
    }
  },
  // ex: 3th monday of Jan => return 3th monday of (Jan + repeatEvery)
  getNextDateByWeekDayInMonth(date, repeatEvery) {
    let result = moment(date).clone().add(repeatEvery, 'month').startOf('month')
    while (date.format('dddd') !== result.format('dddd') || this.weekdayOfMonth(date) !== this.weekdayOfMonth(result)) {
      result = result.add(1, 'day')
    }
    return result
  },
  getNextDateInListWeekDays(startDate, weekDaysAllow, repeatEvery) {
    let result = moment()
    const findDay = (repeatEvery) => {
      return [null, 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].find((day, dayIndex) => {
        if (day) {
          const date = repeatEvery
            ? moment(startDate).clone().day(dayIndex).add(repeatEvery, 'week')
            : moment(startDate).clone().day(dayIndex)
          if (weekDaysAllow.includes(day.toUpperCase()) && date.isAfter(moment(startDate))) {
            result = date
            return true
          }
        }
        return false
      })
    }
    if (!findDay()) {
      findDay(repeatEvery)
    }
    return result
  },
  getNextLessonDate(lessonTime, template, regularPeriod) {
    const isCustomMonthly = template.custom.length > 0 && regularPeriod === 'month'
    const isCustomWeekly = template.daysOfWeek.length > 0 && regularPeriod === 'week'
    const repeatEvery = template.repeatEvery || 1
    if (isCustomMonthly) {
      return dateTimeMethod.getNextDateByWeekDayInMonth(moment(lessonTime).clone(), repeatEvery)
    }
    if (isCustomWeekly) {
      return dateTimeMethod.getNextDateInListWeekDays(lessonTime, template.daysOfWeek, repeatEvery)
    }
    return moment(lessonTime).add(repeatEvery, regularPeriod)
  },
  findOverLapWorkingHour(lessonTimes, workingHours) {
    if (!lessonTimes || !workingHours) return null
    const result = {}
    const isOverlapWorkHours = _.some(_.cloneDeep(lessonTimes), (time) => {
      const day = moment(time.start).format('dddd').toLowerCase()
      const workingHour = workingHours[day]
      const { timeIn, timeOut } = workingHour
      if (!timeIn || !timeOut) return null
      const workingHourStart = new Date(_.cloneDeep(time.start).setHours(...workingHour.timeIn.split(':')))
      const workingHourEnd = new Date(_.cloneDeep(time.start).setHours(...workingHour.timeOut.split(':')))
      if (
        moment(workingHourStart).isBetween(time.start, time.end, null, '[]') ||
        moment(workingHourEnd).isBetween(time.start, time.end, null, '[]') ||
        moment(time.start).isBetween(workingHourStart, workingHourEnd, null, '[]') ||
        moment(time.end).isBetween(workingHourStart, workingHourEnd, null, '[]')
      ) {
        result[day] = workingHour
        return true
      }
      return false
    })
    return isOverlapWorkHours ? result : null
  },
  getEndTime(startTime, lessonDuration) {
    return lessonDuration ? moment(startTime).add(lessonDuration, 'minutes').toDate() : null
  },
  getOverlapWorkingHours(scheduleClass, workingHours, lessonCount, lessonDuration) {
    let overlapsWorkHours = []
    const { startDatetime } = scheduleClass
    const { schedule } = scheduleClass.regularPeriod
    const courseStartDate = dateTimeMethod.utcToDate(startDatetime) // Is also first lesson's date
    const regularPeriod = dateTimeMethod.regular(schedule)
    const lessonTimes = [{ start: courseStartDate, end: dateTimeMethod.getEndTime(courseStartDate, lessonDuration) }]
    if (regularPeriod && lessonCount > 0) {
      // Generate date of each lesson
      for (let lessonNo = 1; lessonNo < lessonCount; lessonNo++) {
        const previousLessonTime = lessonTimes[lessonNo - 1].start
        const lessonTime = dateTimeMethod.getNextLessonDate(
          previousLessonTime,
          scheduleClass.regularPeriod,
          regularPeriod
        )
        lessonTimes.push({ start: lessonTime.toDate(), end: dateTimeMethod.getEndTime(lessonTime) })
      }
    }
    // Checking overlap
    const overlapWorkingHour = dateTimeMethod.findOverLapWorkingHour(lessonTimes, workingHours)
    if (overlapWorkingHour) {
      overlapsWorkHours.push(overlapWorkingHour)
      overlapsWorkHours = _.uniq(overlapsWorkHours)
    }
    return overlapsWorkHours
  },
}
export const dateTimeMixins = {
  methods: {
    ...dateTimeMethod,
  },
}
